'use client';
import { useParams } from 'next/navigation';
import { defaultLang, SUPPORTED } from "../../config/languages";
import PageLayout from "../PageLayout";
import { useTranslation } from "react-i18next";
import { SOLUTION_SECTION } from "../../config/solutionSections";
import SolutionsLayout2 from './Layout2';

export default function Solutions() {
  const { t } = useTranslation(['solutions']);
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const section = SOLUTION_SECTION[activeLang] || SOLUTION_SECTION.en;

  return (
    <PageLayout
      presentLikeHome
      title={t('pageTitle', { ns: 'solutions' })}
      metaDescription={t('pageMetaDescription', { ns: 'solutions' })}
      canonical={`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/${section}`}
    >
      <SolutionsLayout2 />
    </PageLayout>
  );
}
